import Header from '../../components/Header'

type ServiceItem = {
  title: string
  icon: string
  iconClassName?: string
}

const services: ServiceItem[] = [
  {
    title: 'Airport Transfer',
    icon: '/assets/images/service-airport.png',
    iconClassName: 'h-[46px] w-[54px]',
  },
  {
    title: 'Hotel Transfer',
    icon: '/assets/images/service-hotel.png',
    iconClassName: 'h-[48px] w-[66px]',
  },
  {
    title: 'Ski Transfer',
    icon: '/assets/images/service-ski.png',
    iconClassName: 'h-[49px] w-[49px]',
  },
  {
    title: 'Day Trips',
    icon: '/assets/images/Group8.png',
    iconClassName: 'h-[53px] w-[53px]',
  },
  {
    title: 'Private Van Tours',
    icon: '/assets/images/service-europe.png',
    iconClassName: 'h-[47px] w-[47px]',
  },
]

function CurvedBackdrop() {
  return (
    <div
      className="pointer-events-none absolute inset-0 overflow-hidden"
      aria-hidden="true"
    >
      {/* Hero background */}
      <div className="absolute inset-0 bg-[url('/assets/images/abt-hero-banner.png')] bg-cover bg-top bg-no-repeat" />

      {/* Semicircle PNG shape */}
      <img
        src="/assets/images/Ellipse 80.png"
        alt=""
        className="absolute bottom-0 left-1/2 w-full min-w-[1440px] max-w-none -translate-x-1/2"
      />
    </div>
  )
}

export default function AboutHero() {
  return (
    <section className="relative min-h-[820px] overflow-hidden bg-white lg:min-h-[890px]">
      <CurvedBackdrop />
      <Header absolute />

      <div className="relative z-10 mx-auto max-w-page px-5 sm:px-8">

        <div className="relative mx-auto mt-[122px] max-w-[960px] text-center sm:mt-[142px] lg:mt-[145px]">
          <p className="pointer-events-none absolute left-1/2 top-[-91px] -translate-x-1/2 whitespace-nowrap font-host text-[64px] font-bold tracking-[-0.055em] text-[#6F8290]/[0.09] sm:text-[86px] lg:text-[104px]">
            ABOUT US
          </p>

          <p className="font-poppins text-[14px] font-medium tracking-[-0.025em] text-[#292929] sm:text-[15px]">
            Private Transfers From
          </p>

          <h1 className="mt-2 font-host text-[34px] font-semibold leading-none tracking-[-0.035em] text-[#5E7F20] sm:text-[38px]">
            Salzburg
          </h1>

          <p className="mx-auto mt-[23px] max-w-[560px] font-poppins text-[15px] font-medium leading-[1.65] tracking-[-0.025em] text-[#333333] sm:text-[17px]">
            Travel with confidence, comfort, and professional service
            <br className="hidden sm:block" />
            every mile of the way.
          </p>

          <div className="mx-auto mt-[34px] grid max-w-[870px] grid-cols-2 gap-x-6 gap-y-8 sm:grid-cols-3 lg:grid-cols-5 lg:gap-x-[43px]">
            {services.map((service) => (
              <div
                key={service.title}
                className="flex min-w-0 flex-col items-center"
              >
                <div className="flex h-[90px] w-[90px] items-center justify-center rounded-full bg-brand-orange shadow-[0_2px_8px_rgba(255,112,39,0.12)] sm:h-[96px] sm:w-[96px]">
                  <img
                    src={service.icon}
                    alt=""
                    className={`object-contain ${
                      service.iconClassName ?? 'h-12 w-12'
                    }`}
                  />
                </div>

                <p className="mt-[13px] whitespace-nowrap font-host text-[16px] font-medium leading-tight tracking-[-0.035em] text-[#111111] sm:text-[18px]">
                  {service.title}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}